import type { HexaColor } from '@/interfaces/Colors.interfaces'

export const DEFAULT_EVAL_SCALE_COLOR: Readonly<HexaColor> = '#eee'

export const RISKS_REGISTERS_ROUTE_NAME = 'risks'
export const RISKS_REGISTER_ROUTE_NAME = 'risk'

export const RISKS_REGISTER_DISPLAY_VIEWS = {
  LIST: 'list',
  MATRIX: 'matrix',
  MATRIX_NUMBER: 'risk-matrix-number',
}

export const RISK_REGISTERS_LIST_PER_PAGE = 20
